// services are state-less
// they act as utility facades that abstract the details for complex operations
// normally, our interface to any sort of server API will be as a service
import userInfo from 'utils/userInfo';
import { getCityName, getCityID } from '../utils';

const API_DOMAIN = 'https://beta.talkingstreet.in/api';
const SEARCH_DOMAIN = 'https://beta.talkingstreet.in/elastic';
const AHRA_DOMAIN = 'https://beta.talkingstreet.in/ahara_api';

const transformCityData = cities => {
  return cities.map((city, i) => ({
    ...city,
    cityName: city.name,
    cityID: city.name,
  }));
};

const transformSearchResults = results => {
  return results.map((result, i) => {
    return result['_source'];
  });
};

const transformRelated = relatedEatery => {
  return relatedEatery.map(eatery => ({
    ...eatery,
    title: eatery.title,
    city: eatery.city ? eatery.city : null,
    imageUrl: eatery.imageUrl ? eatery.imageUrl : null,
    mustTryDishes: eatery.mustTryDishes ? eatery.mustTryDishes.otherDishes : [],
  }));
};

const transformFeaturedStory = featuredStory => {
  return featuredStory.map(story => ({
    ...story,
    title: story.title,
    curatedBy:
      (story.firstName ? story.firstName : null) +
      ' ' +
      (story.lastName ? story.lastName : null)
        ? (story.firstName ? story.firstName : null) +
          ' ' +
          (story.lastName ? story.lastName : null)
        : null,

    city: story.city ? story.city : null,
    imageUrl: story.imageUrl ? story.imageUrl : null,
    summary: story.description ? story.description : null,
  }));
};

class TSAPI {
  async getBoard() {
    try {
      let response = await fetch(`${API_DOMAIN}/bookmark/board`);
      let results = await response.json();
      return results;
    } catch (error) {
      console.log(error);
      return [];
    }
  }
  async addBookmarkToBoard(json) {
    try {
      let response = await fetch(`${API_DOMAIN}/bookmark/add/`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(json),
      });
      let results = await response.json();
      return results;
    } catch (error) {
      console.log(error);
      return [];
    }
  }

  async getCities() {
    try {
      // let response = await fetch(`${API_DOMAIN}/city/`, setAuthHeader({}));
      let response = await fetch(`${API_DOMAIN}/city/`);
      let cities = await response.json();
      return transformCityData(cities);
    } catch (error) {
      console.error(error);
      return [];
    }
  }
  async getEatery(eateryName) {
    try {
      let response = await fetch(
        `${API_DOMAIN}/eatery/link/${eateryName}?includeComments=true&includeContributions=true&includeCuratorTips=true`
      );
      let eatery = await response.json();
      return eatery;
    } catch (error) {
      console.error(error);
      return [];
    }
  }
  async getTSRecommends(type) {
    try {
      let cityName = getCityName();
      let response = await fetch(
        `${API_DOMAIN}/featured/picks?city=${cityName}&limit=10&resourceTypes=${type}&resourceTypes=STORY`
      );
      let eateries = await response.json();
      return eateries;
    } catch (error) {
      console.error(error);
      return [];
    }
  }
  async getLocalRecommends() {
    try {
      let cityName = getCityName();
      let response = await fetch(
        `${API_DOMAIN}/eatery/local?city=${cityName}&limit=10&offset=0`
      );
      let eateries = await response.json();
      return eateries;
    } catch (error) {
      console.error(error);
      return [];
    }
  }
  async getContributors() {
    try {
      let cityID = getCityID();
      let response = await fetch(
        `${API_DOMAIN}/contributor/city?city=${cityID}&limit=20&offset=0`
      );
      let contributors = await response.json();
      return contributors.content;
    } catch (error) {
      console.error(error);
      return [];
    }
  }
  async getAllContributors() {
    try {
      let response = await fetch(
        `${API_DOMAIN}/contributor/?limit=50&offset=0`
      );
      let contributors = await response.json();
      return contributors.content;
    } catch (error) {
      console.error(error);
      return [];
    }
  }
  async getFollowedContributorsByUser(id) {
    try {
      let response = await fetch(
        `${API_DOMAIN}/follow/following/${id}?&fields=content[id,name,displayName,profilePic.uri,cuisinesOfExpertise,userName]`
      );
      let followedContributors = await response.json();
      return followedContributors;
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  async getNativeEateries() {
    try {
      let cityName = getCityName();
      let response = await fetch(
        `${API_DOMAIN}/eatery/native?city=${cityName}&limit=10&offset=0`
      );
      let eateries = await response.json();
      return eateries;
    } catch (error) {
      console.error(error);
      return [];
    }
  }
  async getCityEateries() {
    try {
      let cityName = getCityName();
      let response = await fetch(
        `${API_DOMAIN}/eatery/city?city=${cityName}&limit=10&offset=0`
      );
      let eateries = await response.json();
      return eateries;
    } catch (error) {
      console.error(error);
      return [];
    }
  }
  async getExperiences() {
    try {
      let cityName = getCityName();
      let response = await fetch(
        `${AHRA_DOMAIN}/event/?cityName=${cityName}&limit=1000&offset=0`,
        {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            //Origin: 'http://13.229.133.162:4114',
          },
        }
      );
      let aharaExper = await response.json();
      const addedExperienceType = aharaExper.content.map(post => {
        return {
          ...post,
          resourceType: 'EXPERIENCE',
        };
      });
      return addedExperienceType;
    } catch (error) {
      console.error(error);
      return [];
    }
  }
  async getAharaCities() {
    try {
      let response = await fetch(`${AHRA_DOMAIN}/city/`);
      let cities = await response.json();
      return cities;
    } catch (error) {
      console.error(error);
      return [];
    }
  }
  async getListicleById(id) {
    try {
      let response = await fetch(`${API_DOMAIN}/listicle/id/${id}/`);
      let listicle = await response.json();
      return listicle.data;
    } catch (error) {
      console.error(error);
      return [];
    }
  }
  // ------- Eatery Page Apis Calls -----------
  async getFeaturedEatery(cityName, type) {
    try {
      let response = await fetch(
        `${API_DOMAIN}/featured/picks?city=${cityName}&limit=10&resourceTypes=${type}`
      );
      let eateries = await response.json();
      return eateries;
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  async getFeaturedStoryForHP() {
    try {
      let cityName = getCityName();
      let response = await fetch(
        `${API_DOMAIN}/featured/picks?city=${cityName}&limit=10&resourceTypes=STORY`
      );
      let story = await response.json();
      return story;
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  async getRelatedEateries(eateryID) {
    try {
      let response = await fetch(
        `${API_DOMAIN}/eatery/related?eateryId=${eateryID}&limit=10&offset=0`
      );
      let related = await response.json();
      return transformRelated(related);
    } catch (error) {
      console.error(error);
      return {
        content: [],
      };
    }
  }

  async getEateryViaId(id) {
    try {
      let response = await fetch(`${API_DOMAIN}/eatery/${id}`);
      let eateryData = await response.json();
      let eatery = {};
      if (eateryData['data']) {
        let data = eateryData['data'];
        if (data['entity']) {
          eatery = data['entity'];
        }
      }
      return eatery;
    } catch (error) {
      console.error(error);
      return {};
    }
  }

  async getAllEateryNames(city) {
    try {
      let response = await fetch(
        `${API_DOMAIN}/eatery/city/?city=${city}&limit=10000&offset=0&fields=id,title,imageUrl`
      );
      let eateries = await response.json();
      return eateries;
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  // ------- Eatery Page Apis Calls Ends-----------

  // ------- Story Page APIs Calls Start Here ------
  async getStory(storyname) {
    try {
      let response = await fetch(`${API_DOMAIN}/story/link/${storyname}`);
      let stories = await response.json();
      return stories;
    } catch (error) {
      console.error(error);
      return [];
    }
  }
  async getListicle(listicleName) {
    try {
      let response = await fetch(
        `${API_DOMAIN}/listicle/title/${listicleName}`
      );
      let listicle = await response.json();
      return listicle;
    } catch (error) {
      console.error(error);
      return [];
    }
  }
  async getStoryID(id) {
    try {
      let response = await fetch(
        `${API_DOMAIN}/story/${id}?includeBookmarkedByUser=true&includeBookmarksCount=true&includeComments=true&includeContributions=true&includeEdits=true`
      );
      let stories = await response.json();
      return stories;
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  async getFeaturedStory(cityName, type) {
    try {
      let response = await fetch(
        `${API_DOMAIN}/featured/picks?city=Bangalore&limit=10&resourceTypes=STORY`
      );
      let stories = await response.json();
      return transformFeaturedStory(stories);
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  async getRelatedStory(storyID) {
    try {
      let response = await fetch(
        `${API_DOMAIN}/story/related?limit=10&offset=0&storyId=${storyID}`
      );
      let relatedS = await response.json();
      return transformRelated(relatedS);
    } catch (error) {
      console.error(error);
      return {
        content: [],
      };
    }
  }

  /*
   * APIs Call for Contributor experience,Contributor Dashboard page
   */
  async getContributorContribution(id) {
    try {
      let response = await fetch(
        `${API_DOMAIN}/contributor/contributions?limit=1000&resourceTypes=EATERY&resourceTypes=STORY&resourceTypes=LISTICLE&userId=${id}`
      );
      let contributions = await response.json();
      return contributions;
    } catch (error) {
      console.log(error);
      return [];
    }
  }

  async getContributorDetails() {
    try {
      let response = await fetch(
        `${API_DOMAIN}/contributor/${userInfo.getUserID()}?includeContentCounts=true`
      );
      let contributorData = await response.json();
      return contributorData;
    } catch (error) {
      console.log(error);
      return [];
    }
  }

  /*
      Api call for contributor profile
  */
  async getContributorProfile(id) {
    try {
      let response = await fetch(
        `${API_DOMAIN}/contributor/${id}?includeContentCounts=true`
      );
      let contributorData = await response.json();
      return contributorData;
    } catch (error) {
      console.log(error);
      return [];
    }
  }
  async getContributorTop(id) {
    try {
      let response = await fetch(`${API_DOMAIN}/contributor/top?userId=${id}`);
      let contributorTop = await response.json();
      return contributorTop;
    } catch (error) {
      console.log(error);
      return [];
    }
  }

  async getContributorPublishedArticle(count) {
    if (count <= 10) {
      try {
        let response = await fetch(
          `${API_DOMAIN}/contributor/contributions?limit=10&resourceTypes=EATERY&resourceTypes=LISTICLE&resourceTypes=STORY&userId=${userInfo.getUserID()}`
        );
        let contributions = await response.json();
        return contributions;
      } catch (error) {
        console.log(error);
        return [];
      }
    } else {
      try {
        let response = await fetch(
          `${API_DOMAIN}/contributor/contributions?limit=400&resourceTypes=EATERY&resourceTypes=LISTICLE&resourceTypes=STORY&userId=${userInfo.getUserID()}`
        );
        let contributions = await response.json();
        return contributions;
      } catch (error) {
        console.log(error);
        return [];
      }
    }
  }
  async getContributorDrafts() {
    try {
      let response = await fetch(
        `${API_DOMAIN}/contributor/draft?limit=500&resourceTypes=EATERY&resourceTypes=LISTICLE&resourceTypes=STORY&resourceTypes=EVENT&userId=${userInfo.getUserID()}`
      );
      let contributorTop = await response.json();
      return contributorTop;
    } catch (error) {
      console.log(error);
      return [];
    }
  }

  async getFollowers() {
    try {
      let response = await fetch(
        `${API_DOMAIN}/follow/${userInfo.getUserID()}/`
      );
      let followers = await response.json();
      return followers;
    } catch (error) {
      console.log(error);
      return [];
    }
  }
  async getUserProfile(id) {
    try {
      let response = await fetch(
        `${API_DOMAIN}//user/${id}?limit=1&offset=0&fields=data[id,name,displayName,profilePic.uri,userProfile.hometown.name]`
      );
      let user = await response.json();
      return user.data;
    } catch (error) {
      console.log(error);
      return [];
    }
  }

  async searchArticles(keyword) {
    keyword = decodeURIComponent(keyword);
    let city = getCityName();
    let cityFilter = '';
    if (city)
      cityFilter = {
        match: {
          'city.name': `${getCityName()}*`,
        },
      };
    try {
      keyword = keyword.toLowerCase();
      let searchJson = {
        query: {
          bool: {
            must: [
              cityFilter,
              {
                bool: {
                  should: [
                    {
                      wildcard: {
                        'tags.name': `${keyword}*`,
                      },
                    },
                    {
                      wildcard: {
                        'location.fullAddress': `${keyword}*`,
                      },
                    },
                    {
                      wildcard: {
                        'location.locality': `${keyword}*`,
                      },
                    },
                    {
                      wildcard: {
                        'cuisines.name': `${keyword}*`,
                      },
                    },
                    {
                      wildcard: {
                        linkTitle: `${keyword}*`,
                      },
                    },
                    {
                      wildcard: {
                        title: `${keyword}*`,
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
        size: 1000,
      };
      let response = await fetch(`${SEARCH_DOMAIN}/eateries/_search`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(searchJson),
      });
      let results = await response.json();
      return transformSearchResults(results.hits.hits);
    } catch (error) {
      console.error(error);
      return [];
    }
  }
  async addListicle(json) {
    try {
      let response = await fetch(`${API_DOMAIN}/listicle/`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(json),
      });
      let results = await response.json();
      return results;
    } catch (error) {
      console.log(error);
      return [];
    }
  }
  async updateListicle(json) {
    try {
      let response = await fetch(`${API_DOMAIN}/listicle/`, {
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(json),
      });
      let results = await response.json();
      return results;
    } catch (error) {
      console.log(error);
      return [];
    }
  }
  async getUserByEmail(email) {
    try {
      let response = await fetch(`${API_DOMAIN}/user/email/${email}`);
      let userInfo = await response.json();
      return userInfo;
    } catch (error) {
      console.error(error);
      return {};
    }
  }
  async getContributorById(id) {
    try {
      let response = await fetch(`${API_DOMAIN}/contributor/${id}/`);
      let userInfo = await response.json();
      return userInfo.data;
    } catch (error) {
      console.error(error);
      return {};
    }
  }
  async getCuisines() {
    try {
      let response = await fetch(`${API_DOMAIN}/cuisine/`);
      let userInfo = await response.json();
      return userInfo;
    } catch (error) {
      console.error(error);
      return {};
    }
  }
  async putContributor(json) {
    try {
      let response = await fetch(`${API_DOMAIN}/contributor/`, {
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(json),
      });
      let results = await response.json();
      return results;
    } catch (error) {
      console.log(error);
      return [];
    }
  }
  async getFollowing() {
    try {
      let response = await fetch(
        `${API_DOMAIN}/follow/following/${userInfo.getUserID()}`
      );
      let following = await response.json();
      return following;
    } catch (error) {
      console.log(error);
      return [];
    }
  }
  async follow(id) {
    try {
      let response = await fetch(`${API_DOMAIN}/follow/`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          follower: userInfo.getUserID(),
          owner: id,
        }),
      });
      let result = await response.json();
      return result;
    } catch (error) {
      console.log(error);
      return [];
    }
  }
  async unFollow(id) {
    try {
      let response = await fetch(`${API_DOMAIN}/follow/${id}`, {
        method: 'DELETE',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          follower: userInfo.getUserID(),
          owner: id,
        }),
      });
      let result = await response.json();
      return result;
    } catch (error) {
      console.log(error);
      return [];
    }
  }
  async getMyDrafts(limit, offset, type) {
    try {
      let response = await fetch(
        `${API_DOMAIN}/contributor/draft?limit=${limit}&offset=${offset}&resourceTypes=${type}&userId=${userInfo.getUserID()}`
      );
      let drafts = await response.json();
      return drafts;
    } catch (error) {
      console.log(error);
      return [];
    }
  }
  async getMyPublished(limit, offset, type) {
    try {
      let response = await fetch(
        `${API_DOMAIN}/contributor/contributions?limit=${limit}&offset=${offset}&resourceTypes=${type}&userId=${userInfo.getUserID()}`
      );
      let drafts = await response.json();
      return drafts;
    } catch (error) {
      console.log(error);
      return [];
    }
  }
  async getMyFollowers(limit, offset) {
    try {
      let response = await fetch(
        `${API_DOMAIN}/follow/${userInfo.getUserID()}?&fields=content[id,name,displayName,profilePic.uri,cuisinesOfExpertise,userName]&limit=${limit}&offset=${offset}`
      );
      let followers = await response.json();
      return followers.content;
    } catch (error) {
      console.log(error);
      return [];
    }
  }
  async getIFollow(limit, offset) {
    try {
      let response = await fetch(
        `${API_DOMAIN}/follow/following/${userInfo.getUserID()}?&fields=content[id,name,displayName,profilePic.uri,cuisinesOfExpertise,userName]&limit=${limit}&offset=${offset}`
      );
      let following = await response.json();
      return following.content;
    } catch (error) {
      console.log(error);
      return [];
    }
  }
  async deleteArticle(type, id) {
    try {
      let typeUri = '';
      if (type === 'EATERY') typeUri = 'eatery';
      else if (type === 'STORY') typeUri = 'story';
      else if (type === 'LISTICLE') typeUri = 'listicle';
      let response = await fetch(`${API_DOMAIN}/${typeUri}/${id}`, {
        method: 'DELETE',
      });
      let following = await response.json();
      return following.content;
    } catch (error) {
      console.log(error);
      return [];
    }
  }
  async createUser(json) {
    try {
      let response = await fetch(`${API_DOMAIN}/user/`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(json),
      });
      let results = await response.json();
      return results[0];
    } catch (error) {
      console.log(error);
      return [];
    }
  }
}

export default new TSAPI();

export { default as amenityApi } from './amenity';
export { default as cityApi } from './city';
export { default as cuisineApi } from './cuisine';
export { default as curatorApi } from './curator';
export { default as eateryApi } from './eatery';
export { default as fileApi } from './file';
export { default as tagApi } from './tag';
export { default as storyApi } from './story';
